import React from 'react';
import { useTranslation } from 'react-i18next';

const Features: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section style={{backgroundColor: 'var(--cream)'}}>
      <div className="container">
        <div className="section-title">
          <h2>{t('why_choose_heading')}</h2>
        </div>
        <div className="grid grid-3">
          <div className="card">
            <div className="card-icon">🌿</div>
            <h3 className="card-title">{t('feature_authentic_title')}</h3>
            <p className="card-text">{t('feature_authentic_desc')}</p>
          </div>
          <div className="card">
            <div className="card-icon">✨</div>
            <h3 className="card-title">{t('feature_unique_title')}</h3>
            <p className="card-text">{t('feature_unique_desc')}</p>
          </div>
          <div className="card">
            <div className="card-icon">🚀</div>
            <h3 className="card-title">{t('feature_franchise_title')}</h3>
            <p className="card-text">{t('feature_franchise_desc')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;